import { useQuery } from '@apollo/client';
import { type BookingFilter } from '@lingoda/booking';
import { UserDisplayedWidgetClassEnum } from '@lingoda/monolith-graphql';
import { LeadTimeExplanationBannerWidgetsDocument } from './leadTimeExplanationBanner.monolith.generated';
import { type LeadTime } from './resolveLeadTime';
import { shouldShowLeadTimeBanner } from './shouldShowLeadTimeBanner';
import { useLeadTime } from './useLeadTime';

export type LeadTimeBanner = { shouldShow: false } | { shouldShow: true; leadTime: LeadTime };

export const useLeadTimeBanner = (bookingFilter: BookingFilter): LeadTimeBanner => {
    const { data } = useQuery(LeadTimeExplanationBannerWidgetsDocument);
    const leadTime = useLeadTime();

    const shouldShow = shouldShowLeadTimeBanner({
        isStudentEligibleToSeeBanner: !!data?.userWidgets?.includes(
            UserDisplayedWidgetClassEnum.LeadTimeExplanationBanner,
        ),
        classType: bookingFilter.classType,
        filterDates: bookingFilter.dates,
        firstDateBeyondLeadTime: leadTime?.firstDateBeyondLeadTime,
    });

    return shouldShow && leadTime ? { shouldShow: true, leadTime } : { shouldShow: false };
};
